import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-input-group',
  templateUrl: './icon-input-group.component.html',
  styleUrls: ['./icon-input-group.component.scss'],
})
export class IconInputGroupComponent implements OnInit {
  @Input() align: string;
  @Input() type: string;
  @Input() icon: string;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() mode: string;
  constructor() {}

  ngOnInit() {}
}
